import { useQuery } from '@tanstack/react-query';
import { MRT_ColumnFiltersState } from 'mantine-react-table';
import { useMemo } from 'react';

import { useContractsQueries } from '../../lib/queries/contracts';

import { getLotsStatsFilters } from '../../lib/lots-filters';

export function useLotsStats(
  filters: MRT_ColumnFiltersState,
  options?: { enabled?: boolean },
) {
  const contractsQueries = useContractsQueries();
  const statsBaseFilters = useMemo(
    () => getLotsStatsFilters(filters, 'total'),
    [filters],
  );

  return useQuery({
    ...contractsQueries.lotsStats(statsBaseFilters),
    enabled: options?.enabled ?? true,
  });
}
